import type {
  StandaloneFormQuestion,
  StandaloneFormQuestionDetail
} from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockStandaloneFormQuestions: StandaloneFormQuestion[] = [
  {
    id: 'formquestion_001',
    key: 'nomination.nominator.firstname',
    type: 'text',
    labelId: 'formcopy_001',
    dashboardLabel: null,
    partnerId: null,
    required: true,
    createdAt: '2026-02-16T13:13:44.430Z',
    localisedLabel: {
      id: 'formcopy_001',
      locales: [
        {
          formCopyId: 'formcopy_001',
          locale: 'en-US',
          value: 'First Name'
        }
      ]
    }
  },
  {
    id: 'formquestion_002',
    key: 'nomination.nominator.email',
    type: 'email',
    labelId: 'formcopy_002',
    dashboardLabel: null,
    partnerId: null,
    required: true,
    createdAt: '2026-02-16T13:13:44.506Z',
    localisedLabel: {
      id: 'formcopy_002',
      locales: [
        {
          formCopyId: 'formcopy_002',
          locale: 'en-US',
          value: 'Email'
        }
      ]
    }
  },
  {
    id: 'formquestion_003',
    key: 'nomination.nominator.group',
    type: 'select',
    labelId: 'formcopy_003',
    dashboardLabel: 'Group selector',
    partnerId: 'partner-123',
    required: false,
    createdAt: '2026-02-16T13:13:44.526Z',
    localisedLabel: {
      id: 'formcopy_003',
      locales: [
        {
          formCopyId: 'formcopy_003',
          locale: 'en-US',
          value: 'Group/Organization'
        }
      ]
    }
  },
  {
    id: 'formquestion_004',
    key: 'organisation.search',
    type: 'organisation_search',
    labelId: 'formcopy_004',
    dashboardLabel: null,
    partnerId: null,
    required: true,
    createdAt: '2026-02-16T13:13:44.585Z',
    localisedLabel: null
  },
  {
    id: 'formquestion_005',
    key: 'contact.firstname',
    type: 'name',
    labelId: 'formcopy_005',
    dashboardLabel: null,
    partnerId: null,
    required: true,
    createdAt: '2026-02-16T13:13:44.600Z',
    localisedLabel: {
      id: 'formcopy_005',
      locales: [
        {
          formCopyId: 'formcopy_005',
          locale: 'en-US',
          value: 'Contact First Name'
        }
      ]
    }
  },
  {
    id: 'formquestion_006',
    key: 'award.amount',
    type: 'award_amount',
    labelId: 'formcopy_006',
    dashboardLabel: null,
    partnerId: null,
    required: true,
    createdAt: '2026-02-16T13:13:44.700Z',
    localisedLabel: {
      id: 'formcopy_006',
      locales: [
        {
          formCopyId: 'formcopy_006',
          locale: 'en-US',
          value: 'Award Amount'
        }
      ]
    }
  }
]

export const mockStandaloneFormQuestionDetails: Record<string, StandaloneFormQuestionDetail> = {
  formquestion_001: {
    id: 'formquestion_001',
    key: 'nomination.nominator.firstname',
    type: 'text',
    label: 'First Name',
    placeholder: '',
    description: '',
    dashboardLabel: null,
    required: true,
    hidden: false,
    order: 1
  },
  formquestion_002: {
    id: 'formquestion_002',
    key: 'nomination.nominator.email',
    type: 'email',
    label: 'Email',
    placeholder: '',
    description: '',
    dashboardLabel: null,
    required: true,
    hidden: false,
    order: 2,
    contactType: 'LEGAL_SIGNATORY'
  },
  formquestion_003: {
    id: 'formquestion_003',
    key: 'nomination.nominator.group',
    type: 'select',
    label: 'Group/Organization',
    placeholder: '',
    description: '',
    dashboardLabel: 'Group selector',
    required: false,
    hidden: false,
    order: 3,
    options: [
      { value: 'group_a', label: 'Group A', conditionalQuestionIds: ['formquestion_001'] },
      { value: 'group_b', label: 'Group B' }
    ]
  },
  formquestion_004: {
    id: 'formquestion_004',
    key: 'organisation.search',
    type: 'organisation_search',
    label: 'Organisation Search',
    placeholder: '',
    description: '',
    dashboardLabel: null,
    required: true,
    hidden: false,
    order: 4,
    addOrganisationQuestions: ['org_name', 'org_country']
  },
  formquestion_005: {
    id: 'formquestion_005',
    key: 'contact.firstname',
    type: 'name',
    label: 'Contact First Name',
    placeholder: '',
    description: '',
    dashboardLabel: null,
    required: true,
    hidden: false,
    order: 5,
    nameType: 'first',
    contactType: 'LEGAL_SIGNATORY'
  },
  formquestion_006: {
    id: 'formquestion_006',
    key: 'award.amount',
    type: 'award_amount',
    label: 'Award Amount',
    placeholder: '',
    description: '',
    dashboardLabel: null,
    required: true,
    hidden: false,
    order: 6,
    validationRules: [
      {
        type: 'candidate_field_comparison',
        operator: '<=',
        candidateField: 'awardRecommendation',
        percentage: 110,
        errorMessage: 'Award amount must not exceed 110% of the recommendation'
      }
    ]
  }
}

export const mockStandaloneFormQuestionsResponse = {
  data: mockStandaloneFormQuestions,
  totalResults: mockStandaloneFormQuestions.length,
  pageSize: 25,
  _links: {
    current: 'https://api.example.com/v1/admin/grants/questions?pageSize=25'
  }
}
